import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Get Clerk publishable key from environment
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

console.log('Clerk key loaded:', CLERK_PUBLISHABLE_KEY ? 'Yes (starts with ' + CLERK_PUBLISHABLE_KEY.substring(0, 10) + '...)' : 'NO - MISSING!');

if (!CLERK_PUBLISHABLE_KEY) {
  // Display error in the page instead of throwing
  document.getElementById('root').innerHTML = '<div style="padding: 20px; color: red;"><h1>Configuration Error</h1><p>Missing REACT_APP_CLERK_PUBLISHABLE_KEY environment variable.</p><p>Create a .env file in namecamper-frontend with:<br/><code>REACT_APP_CLERK_PUBLISHABLE_KEY=pk_test_your_key_here</code></p></div>';
  throw new Error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY environment variable');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
